module.exports = __webpack_public_path__ + "media/Mitsubishi.ed3ec824.mp4";